<div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" (onFileDrop)="fileDrop($event)"
  [uploader]="uploader" class="well my-drop-zone">
  <label>Drag the file here.</label>
</div>